import { Link } from 'react-router-dom';
import { Tile, Button, Tag, InlineNotification } from '@carbon/react';
import { ArrowLeft, IotConnect } from '@carbon/icons-react';

export const AuthInfoTile = () => (
  <Tile className="auth-info-tile">
    <div className="auth-info-brand">
      <IotConnect size={28} />
      <span>SenseStack</span>
    </div>
    <p className="auth-info-text">
      Manage DocuSign-style contracts, send Stripe invoices, and track billable hours — all in one place.
    </p>
    <ul className="auth-info-list">
      <li>Secure sign-in powered by Clerk</li>
      <li>Contract templates with e-signature</li>
      <li>Invoice tracker with client payment links</li>
    </ul>
    <Button kind="ghost" renderIcon={ArrowLeft} as={Link} to="/" className="auth-back-link">
      Back to home
    </Button>
  </Tile>
);

export const ClerkMissingNotice = () => (
  <section className="auth-section">
    <InlineNotification
      kind="error"
      title="Clerk not configured"
      subtitle="Set REACT_APP_CLERK_PUBLISHABLE_KEY in your environment variables."
      hideCloseButton
    />
  </section>
);

export const AuthPageLayout = ({ title, description, tag = 'ACCOUNT', testId, children }) => (
  <section className="auth-section" data-testid={testId}>
    <div className="section-header">
      <Tag type="blue">{tag}</Tag>
      <h2 className="section-title">{title}</h2>
      {description && <p className="section-description">{description}</p>}
    </div>
    <div className="auth-layout">
      <AuthInfoTile />
      <Tile className="auth-form-tile">{children}</Tile>
    </div>
  </section>
);
